$shm_hitalama_map_widget_float_surreal_table $shm_hitalama_map_widget_float
	head_showed true
	columns_text? \
	content /
		<= Table $shm_surreal_table
			profile_id <= profile_id \local
			table_name <= table_name \benchmark_entity
			columns <= columns /
			search_fields <= search_fields /
	settings_content /
		<= Settings $mol_list
			sub /
				<= Table_label $mol_labeler
					title \Таблица
					Content <= Table_input $mol_string
						value? <=> table_name?
				<= Columns_label $mol_labeler
					title \Столбцы
					Content <= Columns_input $mol_textarea
						value? <=> columns_text?
						hint \name, status, value
				<= Connection $shm_surreal_profile_form
					profile_id <= profile_id
